import styled from "styled-components";
import { Button, Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";
import InlineSVG from "react-inlinesvg";

import commonStore from "@zustand/common";
import { colors } from "@constants/colors";
import { checkCondition, checkEmptyString } from "@utils/checkEmpty";
import { icons } from "@constants/icons";

const CenteredModal = () => {
  const [t] = useTranslation();
  const { openCenteredModal } = commonStore();

  const icon = {
    warning: <InlineSVG src={icons.warning} />,
    loading: <Spin size="large" className="loading-common" />,
    error: <InlineSVG src={icons.warning} />,
  };

  return (
    <Contents id="modal-confirm-cancel">
      <Modal
        open={openCenteredModal?.open}
        onOk={openCenteredModal?.onOk}
        onCancel={openCenteredModal?.onClose}
        getContainer={() =>
          document.getElementById("modal-confirm-cancel") as HTMLElement
        }
        closable={false}
        centered
        footer={false}
      >
        {checkCondition(
          openCenteredModal?.type,
          icon[openCenteredModal?.type],
          <></>,
        )}
        <div className="text">
          {t(checkEmptyString(openCenteredModal?.title))}
        </div>
        <div className="destination">
          {t(checkEmptyString(openCenteredModal?.description))}
        </div>
        {openCenteredModal?.btn?.isDisplayBtnConfirm && (
          <Button
            type="primary"
            block
            size="large"
            onClick={openCenteredModal?.onOk}
            disabled={openCenteredModal?.btn?.loadingBtnConfirm}
          >
            {t(
              checkCondition(
                openCenteredModal?.btn?.btnConfirmText,
                checkEmptyString(openCenteredModal?.btn?.btnConfirmText),
                "Common:refresh",
              ),
            )}
          </Button>
        )}
        {openCenteredModal?.btn?.isDisplayBtnCancel && (
          <Button
            type="default"
            size="large"
            block
            onClick={openCenteredModal?.onClose}
            disabled={openCenteredModal?.btn?.loadingBtnCancel}
          >
            {t(
              checkCondition(
                openCenteredModal?.btn?.btnCancelText,
                checkEmptyString(openCenteredModal?.btn?.btnCancelText),
                "Common:back_to_main_page",
              ),
            )}
          </Button>
        )}
      </Modal>
    </Contents>
  );
};

export default CenteredModal;

const Contents = styled.div`
  .ant-modal {
    top: 15px;
    width: 480px;
  }
  .ant-modal-content {
    box-shadow: 2px 1px 8px 0 rgba(10, 10, 16, 0.08);
    border-radius: 16px;
    padding: 24px 16px;
  }
  .ant-modal-footer {
    padding: 0px;
  }
  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    gap: 8px;
  }
  .text {
    color: ${colors.graynormal};
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
  }
  .destination {
    color: ${colors.blackText};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 18px;
    white-space: pre-line;
  }
`;
